import { Link } from "react-router-dom";
import { PARTNER_START, currentUserIsStaffInPartnerPortal } from "utils/referralRouting";
import { fetchPartnerEnrolment } from "../../api/endpoints/enrolment";
import { partnerQueryKeys } from "../../api/queryKeys";
import usePartnerQuery from "../../hooks/usePartnerQuery";

/** A colleague who started referring before the full wizard existed still owes their details. */
const IncompleteDetailsBanner = () => {
  const staff = currentUserIsStaffInPartnerPortal();
  const { data } = usePartnerQuery(partnerQueryKeys.enrolment(), fetchPartnerEnrolment, {
    enabled: staff,
    retry: false,
  });
  if (!staff || !data?.enrolled || data.detailsComplete) return null;
  return (
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
      <p className="m-0 text-sm text-amber-900">
        Your partner profile is missing details such as your address, bank account or photo ID.
      </p>
      <Link to={PARTNER_START} className="text-sm font-semibold text-amber-900 underline">
        Complete my details
      </Link>
    </div>
  );
};

export default IncompleteDetailsBanner;
